export default {
  root: {
    width: 64,
    height: 44,
  },
};
